<div class="delivery-debug-log-modal" [ngClass]="{'no-padding': isDeliveryLogsPopup}">
    <div class="delivery-log-debug-modal-container" *ngIf="!isLoading">
        
        <div class="custom-tooltip" *ngIf="showDebugTooltip">
            <div class="tooltip-title">Sequence Run / Last Run Time / Longest Sequence Run Time</div>
            <div class="tooltip-subtext">
                Note: While a sequence is been pushed on device, the data shows debug information from the last delivered sequence.
            </div>
        </div>

        <div class="header-container" id="ccu-delivery-logs-modal-header">
            <div class="seq-info-container">
                <div class="info-wrapper" id="ccu-delivery-logs-modal-sequence-name">
                    <div class="title">Name</div>
                    <div class="value sequence-name-max-width">{{sequenceName}}</div>
                </div>
                <div class="info-wrapper" id="ccu-delivery-logs-modal-sequence-date">
                    <div class="title">Applied Date & Time</div>
                    <div class="value">{{appliedDate ? appliedDate : '-'}}</div>
                </div>
                <div class="info-wrapper" id="ccu-delivery-logs-modal-sequence-status" *ngIf="isDeliveryLogsPopup">
                    <div class="title">Delivering Status</div>
                    <div class="status-container">
                        <div class="block-icon-container">
                            <img class="block-icon" [src]="deliveryStatus.path" alt="" id="status-icon"
                                [matTooltip]="deliveryStatus.tooltip" matTooltipPosition='below' matTooltipClass="ota-status-tooltip">
                        </div>
                        <div class="value">{{deliveryStatus.status}}</div>
                    </div>
                </div>
            </div>
            <div class="close-button-container">
                <button mat-icon-button mat-dialog-close class="close-button" id="ccu-delivery-logs-modal-close-button">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <div class="deliver-logs-table-container">
            <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort id="ccu-delivery-logs-table" (matSortChange)="onSortChange($event)">
                <ng-container *ngFor="let column of headerColumnNames; let i=index" [matColumnDef]="column" sticky>
                    
                    <!-- Table Header -->
                    <ng-container *ngIf="isSortable(column); else noSort">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="getColumnWidth(column)">
                            {{ getFormattedColumnName(column) }}
                        </th>
                    </ng-container>

                    <!-- Non-sortable Header -->
                    <ng-template #noSort>
                        <th mat-header-cell *matHeaderCellDef [ngClass]="getColumnWidth(column)">
                            <div class="mat-header-title" [ngClass]="{'border-none': i == headerColumnNames.length -1}">
                                {{ getFormattedColumnName(column) }}

                                <!-- Info Icon for Debug Information Column -->
                                <div class="info-icon-container" *ngIf="column === 'debugInformation'"
                                    (mouseenter)="showDebugTooltip = true" (mouseleave)="showDebugTooltip = false">
                                    <img class="info-icon" [src]="'assets/images/info-icon-error.svg'" alt="" id="info-icon">
                                </div>
                            </div>
                        </th>
                    </ng-template>
                    
                    <!-- Table Data -->
                    <td mat-cell *matCellDef="let row">
                        <ng-container [ngSwitch]="column">
                            <!-- Status column -->
                            <ng-container *ngSwitchCase="'status'">
                                <div class="block-icon-container">
                                    <img class="block-icon" [src]="getStatusIconPath(row.status)" alt="" id="status-icon" [matTooltip]="row.status"
                                        matTooltipPosition='below' matTooltipClass="ota-status-tooltip">
                                </div>
                            </ng-container>
                            <!-- zone/ccu name -->
                            <ng-container *ngSwitchCase="'ccuZoneModules'">
                                <p class="data-value" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow
                                    [ngClass]="{'align-left': row.isChild}">{{row.ccuZoneModules}}</p>
                            </ng-container>
                            <!-- delivery-Date Time -->
                            <ng-container *ngSwitchCase="'deliveryDateTime'">
                                <p class="data-value" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>
                                    {{ row.deliveryDateTime ? row.deliveryDateTime : '-' }}
                                </p>
                            </ng-container>
                            <!-- confirmed-Date Time -->
                            <ng-container *ngSwitchCase="'confirmedReceipt'">
                                <p class="data-value" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>
                                    {{ row.confirmedReceipt ? row.confirmedReceipt: '-' }}
                                </p>
                            </ng-container>
                            <!-- Debug Information -->
                            <ng-container *ngSwitchCase="'debugInformation'">
                                <p class="data-value" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>
                                    {{ row.debugInformation ? row.debugInformation: '-' }}
                                </p>
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>
        
                <!-- Header and Row definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>

    <ng-container *ngIf="!isLoading && tableData.length == 0">
        <div class="no-delivery-logs">{{ isDeliveryLogsPopup ? 'No delivery logs available.' : 'No debug information available.'}}</div>
    </ng-container>

    <div *ngIf="isLoading" class="loader-container">
        <ngx-skeleton-loader [theme]="{ 'border-radius': '0', 'height': '25px', 'background-color': '#eff0f1'}" count="4">
        </ngx-skeleton-loader>
    </div>
</div>